import React, { useRef, useEffect, useState } from 'react';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';
import BeatLoader from "react-spinners/BeatLoader";
//import Switch from "react-switch";
import Modal from 'react-modal';

let cropDataArray = []

const customStyles = {
    content: {
        top: '15%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

Modal.setAppElement('#root')
const AiCropHints = (props) => {
    const [aiData, setAiData] = useState(props.aiData);

    const [sortByConfidence, setSortByConfidence] = useState();
    const [selectedArray, setSelectedArray] = useState([]);
    const [cropperRef, setCropperRef] = useState(window.cropperRef);
    const [activeCrop, setActiveCrop] = useState(null)

    const cropHintClicked = (object, index, e) => {
        console.log({ object })
        let activeCrop = index
        let first = object.boundingPoly.vertices.slice(0, 2)
        let second = object.boundingPoly.vertices.slice(2, 4)

        let x = (first[0].x)
        let y = (first[0].y)
        let width = (first[1].x) - (first[0].x)
        let height = (second[1].y) - (first[0].y)

        let cropData = { x: x, y: y, width: width, height: height, id: object.id }
        cropperRef.crop()
        cropperRef.setData(cropData)

        setcropHintTags(buildCropTags(activeCrop).cropHintTags)
        console.log({ activeCrop, index })


    }




    const buildCropTags = (selectedCrop = null) => {
        let selectedAsset = window.elvisContext.activeTab.originalAssetSelection[0]
        let cropHintTags = []
        let cropHintObjects = []
        let aspectRatios
        if (aiData && aiData.uri) {
            aspectRatios = aiData.uri.split("-")[aiData.uri.split("-").length - 1].replace(".json", "").split("_")
        }

        // console.log({ url: aiData.uri })

        if (aiData != "nodata" && aiData != "loadingData" && aiData != undefined) {
            aiData[0].cropHintsAnnotation.cropHints.forEach((obj, index) => {
                let div

                if (window.elvisContext.plugin.type === "action") {


                    let className = "ems_grid-item ems_crop"

                    let selected = (selectedCrop === index)

                    if (selected) {
                        className = "ems_grid-item ems_crop ems_crop-selected"
                    }


                    obj.ratio = aspectRatios[index]
                    obj.numRatio = cacluateRatio(obj.ratio.replace(":", "/"))
                    let containerHeight = 200 / obj.numRatio
                    let imagePercentage = (obj.boundingPoly.vertices[1].x - obj.boundingPoly.vertices[0].x) / 200;
                    let imageWidth = selectedAsset.metadata.width / imagePercentage;
                    let imageOffsetX = obj.boundingPoly.vertices[0].x / imagePercentage
                    let imageOffsetY = obj.boundingPoly.vertices[0].y / imagePercentage;


                    div = <div className={className} onClick={cropHintClicked.bind(this, obj, index)}>
                        <div className="ems_label" >Crop: {aspectRatios[index]}</div>
                        <div className="ems_crop-display-container" style={{ width: "200px", height: `${containerHeight}px` }}>
                            <img className="ems_crop-original-image" src={window.previewWithSecret} alt="" style={{ width: `${imageWidth}px`, top: `-${imageOffsetY}px`, left: `-${imageOffsetX}px` }} />
                        </div>
                    </div>


                } else {
                    div = <div className='ems_tag' >
                        {aspectRatios[index]}
                    </div>
                }

                cropHintObjects.push(obj)
                cropHintTags.push(
                    div
                )

            })
        }

        if (sortByConfidence) {
            cropHintTags = cropHintTags.sort(this.sortLabelsbyConfidenceUp)
        }
   

        window.cropHintObjects = cropHintObjects
        return ({ cropHintTags, cropHintObjects })


    }




    const [cropHintTags, setcropHintTags] = useState(buildCropTags().cropHintTags);
    const [cropHintObjects, setcropHintObjects] = useState(buildCropTags().cropHintObjects);
    return (


        <div className="ems_tool_group-content-item">
            <div className="ems_tool_module" toolmodule="transcription">
                <div className="ems_tool_group-content-item">
                    <div className="ems_item_label">Crop Hints</div>
                    <div className="ems_item_content">
                        <div className="ems_grid ems_grid-2">
                            {cropHintTags}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default AiCropHints;

function cacluateRatio(str) {
    return Function(`'use strict'; return (${str})`)()
}